import type { IUserRole } from '@/types/user'
import { USER_ROLES } from '@/lib/constants/users'
export const USERS = {
  ROLES: {
    [USER_ROLES.ADMIN]: 'Administrador',
    [USER_ROLES.CONSULTANT]: 'Consultor',
    [USER_ROLES.CONSULTANT_ADMIN]: 'Administrador de Consultores',
    [USER_ROLES.VIEWER]: 'Lector',
    [USER_ROLES.EDITOR]: 'Editor',
    [USER_ROLES.AUDITOR]: 'Auditor',
    [USER_ROLES.MDM_EDITOR]: 'Editor de MDM',
    [USER_ROLES.SUPPLIER]: 'Proveedor',
  } satisfies Record<IUserRole, string>,
}
